/* eslint-disable camelcase */
import api from '../../api'

export default {
  namespaced: true,
  state: {
    users: []
  },
  getters: {
    users: state => state.users
  },
  mutations: {
    SET_USERS: (state, data) => {
      state.users = data
    }
  },
  actions: {
    async getUsers (context) {
      const res = await api.getUsers()
      if (res && res.data) {
        const users = res.data
        context.commit('SET_USERS', users)
        return res
      }
      throw new Error(res)
    },
    async activateUser (context, { id }) {
      const res = await api.activateUser(id)
      if (res) {
        return res
      }
      throw new Error(res)
    },
    async deactivateUser (context, { id }) {
      const res = await api.deactivateUser(id)
      if (res) {
        return res
      }
      throw new Error(res)
    }
  }
}
